import React, { useState, useRef, useCallback } from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";
import { ObjValidator, XCircleLoader } from "components";
import { ProjectHeader } from "components/ProjectHeader/ProjectHeader";
import {
  useProject,
  useIsProjectLoading,
} from "stores/project/project/projectStore";
import { PROJECT_CONFIGURATOR_TAB_TYPES } from "variables";
import { ProjectItemProperties } from "../../_ConfiguratorObjs/ProjectItem/SubComponents/ProjectItemProperties";
import { ProjectItemUploads } from "../../_ConfiguratorObjs/ProjectItem/SubComponents/ProjectItemUploads";
import { ProjectSummary } from "../../_ConfiguratorObjs/ProjectItem/SubComponents/ProjectSummary";

import s from "./ProjectItemSame.module.scss";

const ProjectItemSame = Scrivito.connect(({ page }) => {
  const [activeTab, setActiveTab] = useState(
    PROJECT_CONFIGURATOR_TAB_TYPES.PRODUCT_LIST,
  );
  const project = useProject();
  const isLoading = useIsProjectLoading();
  const redirectToProjectConfigurator = page.get(
    "redirectToProjectConfigurator",
  );

  const onRedirectToConfiguratorClick = () => {
    Scrivito.navigateTo(() => redirectToProjectConfigurator, {
      params: { projectId: project?.id },
    });
  };
  const productListRef = useRef({});

  const handleChangeActiveTab = useCallback((e) => {
    setActiveTab(e.target.id);
  }, []);

  if (isLoading) return <XCircleLoader />;

  return (
    <>
      <div className="bg-gray-100">
        <Container className="py-5_5">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex justify-content-between align-items-center gap-4 mb-1">
              <ProjectHeader page={page} productListRef={productListRef} />
            </div>
          </div>
          <h4 className={s.textWrap}>{project?.title}</h4>
        </Container>
      </div>
      <ProjectItemProperties />
      <ProjectSummary
        project={project}
        redirectToProjectConfigurator={redirectToProjectConfigurator}
        onRedirectToConfiguratorClick={onRedirectToConfiguratorClick}
        productListRef={productListRef}
        activeTab={activeTab}
        handleChangeActiveTab={handleChangeActiveTab}
      />
      <ProjectItemUploads />
    </>
  );
});

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <ProjectItemSame {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("ProjectItemSame", CheckedPage);
